import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

type StreamPrize = {
  stream: string;
  image: string;
  alt: string;
  prizes: string[];
};

type PrizesProps = {
  prizeList: StreamPrize[];
};

export default function Prizes(props: PrizesProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { prizeList } = props;

  return (
    <>
      {prizeList.map(({ stream, image, alt, prizes }, index) => (
        <Grid item container key={`${stream}-prizes`}>
          <Grid
            item
            container
            direction="row"
            justifyContent="space-between"
            // HEIGHT OF STREAM PRIZE WITH 3 DOT-POINTS IS 150px
            // 3 DOT-POINTS AND NEWLINE IS 170px
            sx={{ py: 1, minHeight: isMobile ? "auto" : "170px" }}
            data-aos="fade-left"
            data-aos-offset="200"
            data-aos-duration="400"
          >
            <Grid
              item
              sx={{ width: "fit-content" }}
              xs={12}
              md={4}
              display="flex"
              justifyContent="center"
              flexDirection="column"
            >
              <img
                src={image}
                alt={alt}
                style={{ objectFit: "contain", width: "100%", maxHeight: "100px" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <List>
                {prizes.map((prize, index) => (
                  <ListItem
                    key={`${stream}-prize-${index}`}
                    dense
                    sx={{ textAlign: isMobile ? "center" : "left" }}
                  >
                    <ListItemText
                      primary={prize}
                      sx={{
                        display: isMobile ? "block" : "list-item",
                        listStyleType: isMobile ? "none" : "circle",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
          {/* ONLY SHOW DIVIDER BETWEEN PRIZES */}
          {isMobile && index !== prizeList.length - 1 && (
            <Divider
              sx={{ width: "100%", my: 2, bgcolor: "primary.light" }}
              data-aos="fade-left"
              data-aos-offset="200"
              data-aos-duration="400"
            />
          )}
        </Grid>
      ))}
    </>
  );
}
